import React, { Component } from 'react'
import FormRegistroUsuario from '../_Components/FormRegistroUsuario'
import Axios from 'axios'
import { Link } from 'react-router-dom';

class Registro extends Component {

    constructor(props) {
        super(props)
        this.state = {
            toggleExpand: false,
            parametros: ''
        }

        // if( /Android|webOS|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        //     window.location.href = "/signup";
        // }
    }

    async getParametros() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/", {});
            this.setState({ parametros: response.data })
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return (
            <div className="documentation" >
                <nav className={this.state.toggleExpand ?
                    'navbar navbar-expand-lg  navbar-dark bg-dark' : 'navbar navbar-expand-lg  navbar-transparent'}
                    color-on-scroll="500">
                    <div className="container-fluid">
                        <button to="#" className="navbar-toggler navbar-toggler-right" type="button"
                            data-toggle="collapse" aria-controls="navigation-index"
                            aria-expanded={this.state.toggleExpand} aria-label="Toggle navigation"
                            onClick={this.expandir}
                        >
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                        </button>
                        <div id="navigation"
                            className={this.state.toggleExpand ? 'w-100 justify-content-end show' : 'collapse navbar-collapse justify-content-end'}>
                            <ul className={this.state.toggleExpand ? 'rounded navbar-nav bg-dark' : 'rounded navbar-nav'}>
                                <li class="nav-item ">
                                    <a className="btn-fill btn btn-danger text-light mt-4  nav-link" href='https://www.youtube.com/c/SORTEFLASH'>
                                        <div style={{ maxHeight: '2em', marginTop: '-1em' }}><i class="fab fa-youtube"></i>  <span class="ml-3">Acompanhe o sorteio</span></div>

                                    </a>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="#">
                                        Contato
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/regulamento">
                                        Regulamento
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/login">
                                        Fazer Login
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

                <div className="wrapper" style={{ overflow: 'scroll' }}>
                    <div className="" style={{ background: 'none !important' }} filter-color=""><div className="page-header-image" data-paralax="true" style={{
                        backgroundImage: 'url(\'./assets/img/ezgif-6-98e38c9ed05b.webp\')', height: '60em'
                    }}>

                        <div className="filter"></div>
                        <div className="title-container text-center" style={{ top: '80px' }}>
                            <div className="container">
                                <div className="d-flex justify-content-center pt-5">
                                    <div className="card mt-5"
                                        style={{ width: '30em' }}>
                                        <div className="card-body text-left">
                                            <FormRegistroUsuario submitLabel="Registrar-se" perfil="CLIENTE" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default Registro